import { Row, Spin, type SpinProps } from 'antd';
import type React from 'react';

interface LoaderProps extends SpinProps {
  children?: React.ReactNode;
}

export const Loader = ({ children, size }: LoaderProps) => {
  return (
    <Row justify="center">
      <Spin size={size}>{children}</Spin>
    </Row>
  );
};
